import { getPositiveInteger } from "../utils";

export default function EditPracticals({ practicals, setPracticals }) {
  const updatePractical = (number, key, value) => {
    setPracticals((prev) =>
      prev.map((p) => (p.number === number ? { ...p, [key]: value } : p)),
    );
  };

  if (!practicals.length) {
    return;
  }

  return (
    <table className="mini-table">
      <thead>
        <tr>
          <th>№ работы</th>
          <th>Кол-во вариантов</th>
          <th>Дата начала</th>
          <th>Дата завершения</th>
        </tr>
      </thead>
      <tbody>
        {practicals.map((p) => (
          <tr key={p.number}>
            <td className="num-cell">{p.number}</td>
            <td className="num-cell">
              <input
                type="number"
                min="1"
                value={p.variantsCount}
                onChange={(e) =>
                  updatePractical(
                    p.number,
                    "variantsCount",
                    getPositiveInteger(e.target.value),
                  )
                }
              />
            </td>
            <td>
              <input
                type="date"
                value={p.startDate}
                onChange={(e) =>
                  updatePractical(p.number, "startDate", e.target.value)
                }
              />
            </td>
            <td>
              <input
                type="date"
                value={p.endDate}
                onChange={(e) =>
                  updatePractical(p.number, "endDate", e.target.value)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
